import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Row, Col } from 'react-bootstrap';
import { Select, Static, Radio } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import ui from '../../common/services/ui';

const SettingsForm = ({ error, handleSubmit, pristine, data, submitting, submitSucceeded, isReadonly, t }) => {
	const { parents, children, paymentHistories, onParentChange, onChildChange, disableChildInput, disablePaymentInput } = data;
	const notesOptions = ui.paymentNotesOptions(t);
	return (
		<Form onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Row>
				<Col sm={6}>
					<Field name='grade.name' component={Static} label={t('LessonAttendance_Grade')} />
				</Col>
				<Col sm={6}>
					<Field name='lessonDate' component={Static} formatType='date' label={t('LessonAttendance_LessonDate')} />
				</Col>
			</Row>
			<Select
				name='parentId'
				disabled={isReadonly}
				label={t('LessonAttendance_Parent')}
				data={parents}
				emptyLabel={t('Common_PleaseSelect')}
				onChange={onParentChange}
				required
				validate={[validators.required]} />
			<Select
				name='childId'
				disabled={disableChildInput || isReadonly}
				label={t('LessonAttendance_Child')}
				emptyLabel={t('Common_PleaseSelect')}
				onChange={onChildChange} data={children}
				required
				validate={[validators.required]} />
			<Select name='paymentHistoryId'
				disabled={disablePaymentInput || isReadonly}
				label={t('LessonAttendance_PaymentHistory')}
				emptyLabel={t('Common_PleaseSelect')}
				data={paymentHistories}
				required
				validate={[validators.required]} />
			<Field name='notes'
				component={Radio}
				label={t('LessonAttendance_AdditionalInfo')}
				entries={notesOptions}
				required
				validate={[validators.required]} />
		</Form>
	);
};

export default reduxForm({ form: 'generateChildLessonsForm' })(SettingsForm);
